export default __webpack_public_path__ + "static/media/call-action.5bb04e69.jpg";